/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Include_CreatedInputs */

const en_dialog_include_created = /** @type {(inputs: Dialog_Include_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Created at`)
};

const es_dialog_include_created = /** @type {(inputs: Dialog_Include_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir fecha de creación`)
};

/**
* | output |
* | --- |
* | "Include Created at" |
*
* @param {Dialog_Include_CreatedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_include_created = /** @type {((inputs?: Dialog_Include_CreatedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Include_CreatedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_include_created(inputs)
	return en_dialog_include_created(inputs)
});